import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import AuditTrailInvestmentCriteria from "./AuditTrailInvestmentCriteria";
import { InvestmentType } from "../Unauthorised/Investment.enum";
import { EnumHelper } from "@singularsystems/neo-core";

@NeoReport("AuditTrailInvestment", { category: ReportCategory.CombinedReports })
export default class AuditTrailInvestmentReport extends Report<AuditTrailInvestmentCriteria> {

    constructor(private investorInvestmentApiClient = AppService.get(DomainTypes.ApiClients.InvestorInvestment),
private issuerInvestmentApiClient = AppService.get(DomainTypes.ApiClients.IssuerInvestment)) {
        super(AuditTrailInvestmentCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2}>
                <div>
                    <Neo.FormGroupInline label={"Investment Type"}>
                        <Neo.DropDown bind={this.criteria.meta.investmentType} select={{ items: EnumHelper.asList(InvestmentType) }} />
                    </Neo.FormGroupInline>
                    
                    {this.criteria.investmentType === InvestmentType.InvestorInvestment && (
                        <Neo.FormGroupInline label={"Investor Investment"}>
                            <Neo.AutoCompleteDropDown
                            bind={this.criteria.meta.investorInvestmentId}
                            bindDisplay={this.criteria.meta.investorInvestmentName}
                            itemSource={(st) => this.investorInvestmentApiClient.getInvestorInvestmentLookups(st, null, null)}
                            option={item => <>
                                <div style={{ flexBasis: 100 }}>{item.investorName}</div>
                                <div style={{ flexBasis: 100 }}>{item.investorInvestmentId}</div>
                            </>
                            }
                        />
                        </Neo.FormGroupInline>
                    )}

                    {this.criteria.investmentType === InvestmentType.IssuerInvestment && (
                        <Neo.FormGroupInline label={"Issuer Investment"}>
                            <Neo.AutoCompleteDropDown
                            bind={this.criteria.meta.issuerInvestmentId}
                            bindDisplay={this.criteria.meta.issuerInvestmentName}
                            itemSource={(st) => this.issuerInvestmentApiClient.getIssuerInvestmentLookups(st, null, null)}
                            option={item => <>
                                <div style={{ flexBasis: 100 }}>{item.issuerName}</div>
                                <div style={{ flexBasis: 100 }}>{item.issuerInvestmentId}</div>
                            </>
                            }
                        />
                        </Neo.FormGroupInline>
                    )}
                </div>
                <div>
                </div>
            </Neo.GridLayout>
        </div>;
    }
}